export const uri = `${
  process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:4000'
}/graphql`;
